<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-bind="$attrs"
  >
    <path
      d="M8.125 10C8.125 8.9645 8.9645 8.125 10 8.125C11.0355 8.125 11.875 8.9645 11.875 10C11.875 11.0355 11.0355 11.875 10 11.875C8.9645 11.875 8.125 11.0355 8.125 10Z"
      fill="currentColor"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.66797 9.9987C1.66797 11.3649 2.0221 11.8249 2.73038 12.7451C4.1446 14.5824 6.51639 16.6654 10.0013 16.6654C13.4862 16.6654 15.858 14.5824 17.2722 12.7451C17.9805 11.8249 18.3346 11.3649 18.3346 9.9987C18.3346 8.63253 17.9805 8.17247 17.2722 7.25231C15.858 5.415 13.4862 3.33203 10.0013 3.33203C6.51639 3.33203 4.1446 5.415 2.73038 7.25231C2.0221 8.17247 1.66797 8.63253 1.66797 9.9987ZM10.0013 6.8737C8.27541 6.8737 6.8763 8.27281 6.8763 9.9987C6.8763 11.7246 8.27541 13.1237 10.0013 13.1237C11.7272 13.1237 13.1263 11.7246 13.1263 9.9987C13.1263 8.27281 11.7272 6.8737 10.0013 6.8737Z"
      fill="currentColor"
    />
  </svg>
</template>

<script>
export default {
  name: 'EyeIcon',
  inheritAttrs: false,
  props: {
    size: {
      type: [Number, String],
      default: 20
    }
  }
}
</script>